export const ALL_SERVICES = [
  {
    title: "PRI Solutions",
    logoURL: "priLogo.png",
    description: "Custom software, integrations, and automation for enterprise operations.",
    pageId: "pri_solutions",
    imageURL: "priHome.webp",
    detailImageURL: "pri.webp",
  },
  {
    title: "Colocation and Hosting Services",
    logoURL: "colocation.png",
    description:
      "Secure, compliant colocation and hosting engineered for enterprise scale.",
    pageId: "colocation_services",
    imageURL: "colocation_services.webp",
    detailImageURL: "colocation_services.webp",
  },
  {
    title: "Rental Hardware",
    logoURL: "hardware.png",
    description: "Short-term hardware rental for projects, buildouts, and disaster recovery.",
    pageId: "rental_hardware",
    imageURL: "rental_hardware.webp",
    detailImageURL: "rental_hardware.webp",
  },
  {
    title: "IT Consultation & Services",
    logoURL: "consultation.png",
    description:
      "Expert IT strategy, infrastructure planning, and managed service support.",
    pageId: "it_consultation",
    imageURL: "it_consultation.webp",
    detailImageURL: "it_consultation.webp",
  },
  {
    title: "Security as a Service",
    logoURL: "security.png",
    description:
      "Proactive cybersecurity monitoring and risk mitigation for your business.",
    pageId: "security_as_service",
    imageURL: "security.webp",
    detailImageURL: "security.webp",
  },
  {
    title: "Dedicated Servers",
    logoURL: "server.png",
    description: "High-performance dedicated compute with premium network capacity.",
    pageId: "dedicated_servers",
    imageURL: "dedicated_servers.webp",
    detailImageURL: "dedicated_servers.webp",
  },
  {
    title: "VPS Services",
    logoURL: "vps.png",
    description: "Flexible VPS hosting with predictable performance and uptime.",
    pageId: "vps_services",
    imageURL: "vps_services.webp",
    detailImageURL: "vps_services.webp",
  },
  {
    title: "Cloud Services",
    logoURL: "cloud.png",
    description: "Hybrid cloud solutions built for performance, compliance, and backup.",
    pageId: "cloud_services",
    imageURL: "cloud_services.webp",
    detailImageURL: "cloud_services.webp",
  },
  {
    title: "Certificates and Compliances",
    logoURL: "certificates.png",
    description:
      "Certification and compliance support for regulated IT environments.",
    pageId: "certifications_compliances",
    imageURL: "certifications_compliances.webp",
    detailImageURL: "certifications_compliances.webp",
  },
  {
    title: "Engineers as a Service",
    logoURL: "engineers.png",
    description: "Senior engineering resources on demand for deployment and operations.",
    pageId: "engineers_service",
    imageURL: "engineers_service.webp",
    detailImageURL: "engineers_service.webp",
  },
  {
    title: "Software development",
    logoURL: "software.png",
    description: "Custom software engineering, deployment, and integration services.",
    pageId: "software_development",
    imageURL: "software_development.webp",
    detailImageURL: "software_development.webp",
  },
];

export const ALL_Products = [
  {
    title: "Microsoft",
    logoURL: "microsoft.png",
    pageId: "erp-solution",
    description:
      "We offer Microsoft ERP solutions to streamline business operations and enhance efficiency with integrated management tools.",
  },
  {
    title: "Linux",
    logoURL: "linux.png",
    pageId: "hms",
    description:
      "We provide Linux-based solutions for stable, secure, and flexible server environments to meet business needs.",
  },
  {
    title: "Web Panels",
    logoURL: "web-panel.png",
    pageId: "idsoftware",
    description:
      "Our web panels enable easy control and monitoring of security systems to detect and prevent network threats.",
  },
  {
    title: "Servers",
    logoURL: "server.png",
    pageId: "microsoft-nav",
    description:
      "We offer powerful server solutions to support business operations with secure, scalable, and reliable infrastructure.",
  },
  {
    title: "Switches",
    logoURL: "switches.png",
    pageId: "idsoftware",
    description:
      "We provide network switches that ensure smooth, high-performance communication across your business network.",
  },
  {
    title: "Storage",
    logoURL: "storage.png",
    pageId: "microsoft-nav",
    description:
      "We offer reliable storage solutions to safeguard and manage your critical business data.",
  },
];

export const About_Company = [
  {
    title: "About Us",
    logoURL: "about-us.png",
    pageId: "about-us",
    description:
      "Learn how QuantaRock combines data center operations, cloud infrastructure, and managed IT to support growing businesses.",
    detailImageURL: "about-us.webp",
  },
  {
    title: "Brands and Partners",
    logoURL: "partners.png",
    pageId: "brand-partners",
    description:
      "Trusted partnerships with leading technology vendors to deliver enterprise-grade IT solutions.",
    detailImageURL: "partners.webp",
  },
  {
    title: "Testimonials",
    logoURL: "testimonials.png",
    pageId: "testimonials",
    description:
      "Customer success stories highlighting how our infrastructure and support create measurable value.",
    detailImageURL: "testimonials.webp",
  },
  {
    title: "Careers at QuantaRock",
    logoURL: "careers.png",
    pageId: "careers",
    description:
      "Join a growing team building secure infrastructure and enterprise technology solutions.",
    detailImageURL: "careers.webp",
  },
  {
    title: "Our Certificates",
    logoURL: "certificates.png",
    pageId: "certificates",
    description:
      "View our certifications and compliance credentials that demonstrate quality and security.",
    detailImageURL: "close-up-graduation-diploma.webp",
  },
];

export const Header_Menu_Items = [
  { title: "Home", pageId: "/" },
  {
    title: "Services",
    subMenu: [...ALL_SERVICES],
    pageId: "/services",
    promo: {
      image: "Services/dataCenter.webp",
      heading: "Not sure where to start?",
      subheading:
        "Talk to our infrastructure team and get a tailored recommendation for your workload, compliance needs, and budget — no obligation.",
      ctaText: "Talk to an expert",
      ctaLink: "/contact",
    },
  },
  {
    title: "Data Centers",
    pageId: "/data-centers",
  },
  // {
  //   title: "Products",
  //   subMenu: [...ALL_Products],
  //   pageId: "/products",
  // },
  {
    title: "Company",
    subMenu: [...About_Company],
    pageId: "/company",
    promo: {
      image: "HomeImages/team-office.webp",
      heading: "Built on trust, backed by expertise",
      subheading:
        "ISO 27001 and 9001 certified, with a team that's supported enterprises across 19 Indian cities since day one.",
      ctaText: "Meet the team",
      ctaLink: "/company/about-us",
    },
  },
  { title: "Contact Us", pageId: "/contact" },
  { title: "FAQ", pageId: "/resources/faq" },
];

export const ALL_DETAIL_ROUTES_INFO = [
  ...ALL_SERVICES,
  ...Header_Menu_Items,
  ...ALL_Products,
  ...About_Company,
];
